/**
 *
 * @param  {Array} permissionList 用户权限集合
 * @param  {Array} allRouter  前端配置好的所有动态路由的集合
 * @return {Array} realRoutes 过滤后的路由
 */

import store from "@/store"

export function recursionRouter(permissionList = [], allRouter = [], isDepartmentAdmin, isSuperAdmin) {
    let realRoutes = [];
    let isGZTV = store.state.config.profile == 'gztv';
    allRouter.forEach((item) => {
        if (!item.meta.nameKey || hasPermission(permissionList, item.meta.nameKey)) {
            if(!item.meta.hideInGZTV || item.meta.hideInGZTV != isGZTV){
                if(!item.meta.isSuperAdmin || isSuperAdmin){
                    realRoutes.push(item);

                }else {
                    if(!item.meta.isDepartmentAdmin || isDepartmentAdmin) {
                        realRoutes.push(item);
                    }
                }
            }
        }
    });
    return realRoutes;
}

function hasPermission(permissionList, nameKey) {
    if(nameKey instanceof Array) {
        return nameKey.find(key => hasPermission(permissionList, key));
    }
    return permissionList.indexOf(nameKey) > -1;
}

/**
 *
 * @param {Array} routes 用户过滤后的路由
 *
 * 递归为所有有子路由的路由设置第一个children.path为默认路由
 */
export function setDefaultRoute(routes) {
    routes.forEach((v, i) => {
        if (v.children && v.children.length > 0) {
            v.redirect = v.path + "/" +  v.children[0].path;
            setDefaultRoute(v.children)
        }
    })
}
